export default __webpack_public_path__ + "static/media/Star 5.d74ac984.svg";